export default "__VITE_ASSET__SFhuNGCI__"